function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_9074",
  "data-name": "Group 9074",
  transform: "translate(-1226.667 -216.667)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_16684",
  "data-name": "Path 16684",
  d: "M1395.556,323.333h8.888v-12.05a35.411,35.411,0,0,1-8.888-23.5Z",
  fill: "#094bbf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_16685",
  "data-name": "Path 16685",
  d: "M1404.444,264.273a35.525,35.525,0,0,0,0,47.01v-47.01Z",
  fill: "#094bbf"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_9067",
  "data-name": "Group 9067"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3832",
  "data-name": "Rectangle 3832",
  width: 8.889,
  height: 71.111,
  transform: "translate(1351.111 252.222)",
  fill: "#094bbf"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3833",
  "data-name": "Rectangle 3833",
  width: 8.889,
  height: 26.667,
  transform: "translate(1351.111 261.111) rotate(-90)",
  fill: "#094bbf"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_9068",
  "data-name": "Group 9068"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3834",
  "data-name": "Rectangle 3834",
  width: 8.889,
  height: 71.111,
  transform: "translate(1484.444 252.222)",
  fill: "#094bbf"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_9069",
  "data-name": "Group 9069"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3835",
  "data-name": "Rectangle 3835",
  width: 8.889,
  height: 71.111,
  transform: "translate(1617.778 252.222)",
  fill: "#094bbf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_16686",
  "data-name": "Path 16686",
  d: "M1591.111,252.222a35.556,35.556,0,1,0,35.556,35.556A35.555,35.555,0,0,0,1591.111,252.222Zm0,62.222a26.667,26.667,0,1,1,26.667-26.666A26.667,26.667,0,0,1,1591.111,314.444Z",
  fill: "#094bbf"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_9070",
  "data-name": "Group 9070"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_16687",
  "data-name": "Path 16687",
  d: "M1404.444,216.667h-8.888v71.111a35.411,35.411,0,0,1,8.888-23.505Z",
  fill: "#094bbf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_16688",
  "data-name": "Path 16688",
  d: "M1431.111,252.222a35.556,35.556,0,1,0,35.556,35.556A35.555,35.555,0,0,0,1431.111,252.222Zm0,62.222a26.667,26.667,0,1,1,26.667-26.666A26.667,26.667,0,0,1,1431.111,314.444Z",
  fill: "#094bbf"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_16689",
  "data-name": "Path 16689",
  d: "M1280,216.667A53.333,53.333,0,1,0,1333.333,270,53.333,53.333,0,0,0,1280,216.667Zm0,97.777A44.444,44.444,0,1,1,1324.444,270,44.444,44.444,0,0,1,1280,314.444Z",
  fill: "#094bbf"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_9072",
  "data-name": "Group 9072"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_9071",
  "data-name": "Group 9071"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3836",
  "data-name": "Rectangle 3836",
  width: 8.889,
  height: 88.889,
  transform: "translate(1528.889 323.333) rotate(180)",
  fill: "#094bbf"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3837",
  "data-name": "Rectangle 3837",
  width: 35.556,
  height: 8.889,
  transform: "translate(1511.111 252.222)",
  fill: "#094bbf"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_9073",
  "data-name": "Group 9073"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3838",
  "data-name": "Rectangle 3838",
  width: 8.889,
  height: 106.667,
  transform: "translate(1653.333 323.333) rotate(180)",
  fill: "#094bbf"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3839",
  "data-name": "Rectangle 3839",
  width: 8.889,
  height: 8.889,
  transform: "translate(1493.333 234.444) rotate(90)",
  fill: "#094bbf"
}));

var SvgBlue = function SvgBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 106,
    viewBox: "0 0 426.666 106.667",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blue.450a9fb1.svg";
export { ForwardRef as ReactComponent };